// @ts-strict-ignore
import React from 'react';
import type { Axis } from '../../AxisHeaderDropdown';
import { StyledBox, StyledTextField } from './styles';

export interface AxisHeaderExactInputProps {
  axis: Axis;
  values: {
    exact: { index: number; value: string };
  };
  onChange: ({ axis, index, value }) => void;
}

export default function AxisHeaderExactInput({
  axis, values, onChange,
}: AxisHeaderExactInputProps) {
  const [input, setInput] = React.useState(values.exact.value);

  const handleOnInput = ({ target: { value } }) => {
    setInput(value);
  };

  const handleOnBlur = () => {
    if (values.exact.value !== input) {
      onChange({
        axis,
        index: values.exact.index,
        value: input,
      });
    }
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', 'Tab'].includes(e.key)) {
      handleOnBlur();
    }
  };

  return (
    <StyledBox>
      <StyledTextField
        autoComplete="off"
        type="text"
        placeholder="value"
        value={input}
        onChange={handleOnInput}
        onBlur={handleOnBlur}
        onKeyDown={handleOnKeyDown}
      />
    </StyledBox>
  );
}
